import { Image } from '../Image/Image';
import { MarkdownParagraph } from './MarkdownParagraph';
import { IMarkdownRenderers } from './IMarkdownRenderers';

export const defaultMarkdownRenderers: IMarkdownRenderers = {
	p: MarkdownParagraph,
	img: Image,
};
